import type {
  SupplierPalletShipmentListParametersType,
  SupplierPalletShipmentListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";

import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../../../hooks/api/v2/apiV2Request";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { ServerStateKeys } from "../../../hooks/api/v2/ServerStateKeys";

export const useSellarDistributionPalletShipmentList = <
  TData extends SupplierPalletShipmentListResponseType =
    SupplierPalletShipmentListResponseType,
>(
  params: SupplierPalletShipmentListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [
      business?.id,
      ServerStateKeys.SellarDistributionPalletShipment,
      params,
    ],
    queryFn: ({ pageParam }) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "distribution-pallet-shipment",
        params: {
          ...params,
          offset: pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: { ...options, limit: params.limit },
    }),
  });
};
